import { motion } from "framer-motion";

const AnimationGraph = () => {
  return (
    <div className="w-full h-[300px] flex items-center justify-center bg-pink-50 rounded-xl relative overflow-hidden p-4">
      <motion.span
        initial={{ opacity: 0, rotate: 270 }}
        animate={{ opacity: 1, rotate: 270 }}
        transition={{ delay: 1 }}
        className="absolute bottom-[65%] right-[85%] text-gray-700 font-medium whitespace-nowrap"
      >
        Program Fit
      </motion.span>
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="absolute bottom-[2%] left-[55%] text-gray-700 font-medium"
      >
        Ingredients Fit
      </motion.span>
      {/* Axes */}
      <motion.div
        initial={{ scaleY: 0, opacity: 0 }}
        animate={{ scaleY: 1, opacity: 1 }}
        transition={{ duration: 1 }}
        className="absolute bottom-8 left-8 w-px h-[80%] bg-gray-400 origin-bottom"
      />
      <motion.div
        initial={{ scaleX: 0, opacity: 0 }}
        animate={{ scaleX: 1, opacity: 1 }}
        transition={{ duration: 1, delay: 0.3 }}
        className="absolute bottom-8 left-8 h-px w-[80%] bg-gray-400 origin-left"
      />

      {/* Selfcare gray lines */}
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "35%" }}
        transition={{ duration: 1, delay: 0.8 }}
        className="absolute bottom-[40%] left-8 h-px bg-gray-600"
      />
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: "30%" }}
        transition={{ duration: 1, delay: 0.8 }}
        className="absolute bottom-8 left-[42%] w-px bg-gray-600"
      />
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.3 }}
        className="absolute bottom-[38%] left-[40%] w-4 h-4 bg-gray-600 rounded-full"
      />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-[40%] left-[22%] text-gray-700 font-medium"
      >
        Selfcare
      </motion.span>

      {/* Solvi pink lines */}
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: "70%" }}
        transition={{ duration: 1, delay: 1.7 }}
        className="absolute bottom-[80%] left-8 h-px bg-pink-400"
      />
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: "70%" }}
        transition={{ duration: 1, delay: 1.7 }}
        className="absolute bottom-8 left-[80%] w-px bg-pink-400"
      />
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2.2 }}
        className="absolute bottom-[77%] left-[78%] w-5 h-5 bg-pink-400 rounded-full"
      />
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.4 }}
        className="absolute bottom-[80%] left-[67%] text-pink-500 font-medium"
      >
        Solvi
      </motion.span>
    </div>
  );
};

export default AnimationGraph;
